import React from 'react'
import { useTranslation } from 'react-i18next'

const TokenSelectorHeader: React.FC = () => {
  const { t } = useTranslation('tokenSelector')

  return (
    <div className='flex justify-between items-center'>
      <div className='typo-label2 font-medium text-main-accent'>
        {t('title')}
      </div>
    </div>
  )
}

export default TokenSelectorHeader
